import React, { useState, useEffect } from 'react';
import { Row, Col, Alert, Form, Button } from 'react-bootstrap';
import { useHistory, Link } from 'react-router-dom';
import { toast } from 'react-toastify';

import { getQueryString } from 'Utils/Helpers';
import { verifyActivationToken, activationToken } from 'Services/AuthService';

import * as yup from 'yup';
import { Formik } from 'formik';
import PasswordInput from 'Components/UI/PasswordInput';

const schema = yup.object({
    Password: yup
        .string()
        .required('Le mot de passe est requis')
        .min(8, 'Le mot de passe doit contenir au moins 8 caractères')
        .matches(/[A-Z]/, 'Le mot de passe doit contenir au moins une lettre majuscule')
        .matches(/[a-z]/, 'Le mot de passe doit contenir au moins une lettre minuscule')
        .matches(/\d/, 'Le mot de passe doit contenir au moins un chiffre')
        .matches(
            /[!@#$%^&*(),.?":{}|<>_\-+=\[\]\\;'/~`|]/,
            'Le mot de passe doit contenir au moins un caractère spécial',
        ),
    ConfirmPassword: yup
        .string()
        .oneOf([yup.ref('Password'), null], 'Les mots de passe doivent correspondre')
        .min(3)
        .required('La confirmation du mot de passe est requise'),
});

const Activation = ({ match: { params }, location }) => {
    const getInitQuery = () => getQueryString(location.search, 'init');

    const history = useHistory();
    const [init, setInit] = useState(getInitQuery());
    const [isValide, setIsValide] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        setInit(getInitQuery());
        const verifyToken = async () => {
            try {
                const { status } = await verifyActivationToken(params.token);
                if (status === 200) setIsValide(true);
                else throw new Error();
            } catch (err) {
                const {
                    response: {
                        data: { message },
                    },
                } = err;
                setError(message || 'Error occured!');
            }
        };
        verifyToken();
    }, [params, location]);

    const submitForm = async (formValues) => {
        try {
            setError(null);
            const {
                status,
                data: { message },
            } = await activationToken(params.token, formValues, init);
            if (status === 200) {
                toast.success(message);
                const appId = getQueryString(location.search, 'goToAppId');
                if (appId) history.replace(`/apps?appId=${appId}`);
                else history.replace('/login');
            } else throw new Error();
        } catch (err) {
            console.log(err);
            const {
                response: {
                    data: { message },
                },
            } = err;
            setError(message || 'Error occured!');
        }
    };

    return (
        <>
            <Row>
                <Col xs={12} md={{ span: 4, offset: 4 }}>
                    <div className="text-center py-3 mt-3">
                        <h2 className="mb-0">{init === '1' ? 'Réactivation de compte' : 'Activation de compte'}</h2>
                        {!error && <p>Changement de mot de passe</p>}
                        {error && (
                            <>
                                <Alert variant="danger">{error}</Alert>
                                <Link to="/login">Aller à la page de connexion</Link>
                            </>
                        )}
                    </div>
                </Col>
            </Row>
            {isValide === true && (
                <Row>
                    <Col xs={12} md={{ span: 4, offset: 4 }}>
                        <Formik
                            validationSchema={schema}
                            onSubmit={(values) => submitForm(values)}
                            enableReinitialize={true}
                            initialValues={{
                                Password: '',
                                ConfirmPassword: '',
                            }}
                        >
                            {({ handleSubmit, handleChange, values, errors }) => (
                                <Form noValidate onSubmit={handleSubmit}>
                                    <Form.Group controlId="exampleForm.ControlPassword">
                                        <Form.Label>Mot de passe</Form.Label>
                                        <PasswordInput
                                            placeholder="Mot de passe"
                                            name="Password"
                                            value={values.Password}
                                            onChange={handleChange}
                                            isInvalid={!!errors.Password}
                                            errorMsg={errors.Password}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.Password}</Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group controlId="exampleForm.ControlConfirmPassword">
                                        <Form.Label>Confirmer le mot de passe</Form.Label>
                                        <PasswordInput
                                            placeholder="Confirmer le mot de passe"
                                            name="ConfirmPassword"
                                            value={values.ConfirmPassword}
                                            onChange={handleChange}
                                            isInvalid={!!errors.ConfirmPassword}
                                            errorMsg={errors.ConfirmPassword}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.ConfirmPassword}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Button variant="primary" type="submit" block>
                                        Enregistrer
                                    </Button>
                                </Form>
                            )}
                        </Formik>
                    </Col>
                </Row>
            )}
        </>
    );
};

export default Activation;
